import React from 'react'
import { Container } from '../../../components'

const MainContent = () => {
  return (
    <Container>
      <div className="pt-8 lg:pt-20 pb-16 lg:pb-24">
        <div className="flex flex-wrap mb-6 lg:mb-12 -mx-4">
          <div className="md:w-6/12 lg:w-6/12 px-4">
            <h2 className="font-primary text-lg font-bold mb-2 pr-4 lg:pr-16">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint?</h2>
          </div>
          <div className="md:w-6/12 lg:w-6/12 px-4 text-gray-444 text-sm entry-content">
            <p>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.</p>
          </div>
        </div>

        <div className="flex flex-wrap mb-6 lg:mb-12 -mx-4">
          <div className="md:w-6/12 lg:w-6/12 px-4">
            <h2 className="font-primary text-lg font-bold mb-2 pr-4 lg:pr-16">Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet?</h2>
          </div>
          <div className="md:w-6/12 lg:w-6/12 px-4 text-gray-444 text-sm entry-content">
            <p>Mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.</p>
          </div>
        </div>

        <div className="flex flex-wrap mb-6 lg:mb-12 -mx-4">
          <div className="md:w-6/12 lg:w-6/12 px-4">
            <h2 className="font-primary text-lg font-bold mb-2 pr-4 lg:pr-16">Deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.?</h2>
          </div>
          <div className="md:w-6/12 lg:w-6/12 px-4 text-gray-444 text-sm entry-content">
            <p>Consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.</p>
          </div>
        </div>

        <div className="flex flex-wrap -mx-4">
          <div className="md:w-6/12 lg:w-6/12 px-4">
            <h2 className="font-primary text-lg font-bold mb-2 pr-4 lg:pr-16">Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint?</h2>
          </div>
          <div className="md:w-6/12 lg:w-6/12 px-4 text-gray-444 text-sm entry-content">
            <p>Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet. </p>
          </div>
        </div>
      </div>
    </Container>
  )
}

export { MainContent }
